import React from 'react';
import Price from './Price';
const PriceS = ({ color, ...props }) => (React.createElement(Price, Object.assign({ color: color, size: 24 }, props)));
PriceS.displayName = 'PriceS'; // Fix for tsc
export default PriceS;
//# sourceMappingURL=PriceS.js.map